import { GET, POST, PUT, DELETE } from "../../api";

export const findAll = async (currentPage, perPage, search) => {
  return await GET(
    `/admin/notifications/notifications?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}`,
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/notifications/notifications/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/notifications/notifications`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/notifications/notifications/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/notifications/notifications/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/notifications/notifications/${id}`);
};

export const sendNotificationToall = async (id) => {
  return await POST(`/admin/notifications/notifications-send/${id}`);
};
